// src/components/DistrictList/DistrictList.js
import React from "react";
import { Grid, Button, useTheme } from "@mui/material";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import {
  buttonStyles,
  gridStyles,
} from "./DistrictList.styles";

function DistrictList({ districts, variantId, product, price }) {
  const theme = useTheme();
  const navigate = useNavigate();

  const handleDistrictClick = (variantId, district, product) => {
    navigate("/payment", {
      state: { product, variantId, district },
    });
  };

  return (
    <Grid container spacing={1} sx={gridStyles}>
      {districts.map((district, index) => (
        <Grid item xs={12} sm={6} key={index}>
          <motion.div
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.3, delay: index * 0.1 }}
          >
            <Button
              fullWidth
              variant="contained"
              color="secondary"
              sx={buttonStyles(theme)}
              onClick={() =>
                handleDistrictClick(variantId, district, { ...product, price })
              }
            >
              {district}
            </Button>
          </motion.div>
        </Grid>
      ))}
    </Grid>
  );
}

export default DistrictList;
